// 言語スイッチ
let eng = document.querySelector('#English a');
let eng_element = document.createElement('span');
eng_element.textContent = 'EN';
eng.appendChild(eng_element);
eng.removeAttribute('href');

let jp = document.querySelector('#Japanese a');
let jp_element = document.createElement('span');
jp_element.textContent = 'JP';
jp.appendChild(jp_element);
jp.removeAttribute('href');

// ローディング
// window.addEventListener('DOMContentLoaded', () => {
//   const loadingLogo = document.querySelector('.p-loading__media');
//   const loading = document.querySelector('.p-loading');
//   loading.classList.add('is-active')
//   setTimeout(function() {
//     loadingLogo.classList.add('is-active');
//   }, 1000);
//   setTimeout(function() {
//     loading.classList.remove('is-active');
//     loadingLogo.classList.remove('is-active');
//   }, 4000);
// });

const sessionKey = "accesed";
const sessionValue = true;

//sessionStorageにsessionKeyというデータの有無を判別
if (!sessionStorage.getItem(sessionKey)) {

  const loadingLogo = document.querySelector('.p-loading__media');
  const loading = document.querySelector('.p-loading');

window.addEventListener('DOMContentLoaded', () => {
  setTimeout(function() {
    loadingLogo.classList.add('is-active');
  }, 1000);
  setTimeout(function() {
    loading.classList.add('is-hidden');
    loadingLogo.classList.remove('is-active');
  }, 4000);
  sessionStorage.setItem(sessionKey, sessionValue);
});
} else {
  //ここに通常アクセス時の処理
  console.log("アクセス済み");

  const loadingLogo = document.querySelector('.p-loading__media');
  const loading = document.querySelector('.p-loading');

  loading.classList.add('is-hidden');
  loadingLogo.classList.remove('is-active');
}

// ハンバーガーメニュー
document.addEventListener('DOMContentLoaded', function() {
  function addActive() {
      document.querySelector('.c-hamburger').classList.toggle('is-active')
      document.querySelector('.c-hamburger__line1').classList.toggle('is-active')
      document.querySelector('.c-hamburger__line2').classList.toggle('is-active')
      document.querySelector('.c-hamburger__line3').classList.toggle('is-active')
      document.querySelector('.c-hamburger__nav').classList.toggle('is-active')
      document.querySelector('body').classList.toggle('fixed');
  }
  document.querySelector('.c-hamburger').addEventListener('click', function() {
      addActive();
  });
})

// TOPに戻るボタン
let scroll = new SmoothScroll('a[href*="#"]', {
  speedAsDuration: true,
  speed: 1000,
  easing: 'easeInOutQuint'
})